import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Russian-only banner announcing inclusion in the Russian Software Registry
export const RosRegistryBanner = () => {
  const { t, i18n } = useTranslation();
  const isRussian = i18n.language === "ru";

  useEffect(() => {
    if (!isRussian) return;
    // Inject scoped CSS to keep styles close to the component
    const style = document.createElement("style");
    style.setAttribute("data-component", "ros-registry-banner");
    style.innerHTML = `
      #ros-registry-banner {
        position: relative;
        padding: 60px 0;
        color: #fff;
        background-color: #0b0b0b;
        overflow: hidden;
      }
      /* New emblem layer (image above backgrounds but behind text) */
      #ros-registry-banner .emblem-layer {
        position: absolute;
        inset: 0;
        z-index: 1;
        pointer-events: none;
        overflow: hidden;
      }
      #ros-registry-banner .emblem-layer .emblem-img {
        position: absolute;
        left: -10vw;
        top: 50%;
        transform: translateY(-50%);
        width: 80vw;
        height: auto;
        opacity: 0.14;
        filter: drop-shadow(0 0 10px rgba(0,0,0,0.25));
        user-select: none;
        -webkit-user-drag: none;
      }
      /* Gradient overlay disabled per design request */
      #ros-registry-banner .overlay-gradient { display: none; }
      #ros-registry-banner .content {
        position: relative;
        z-index: 2;
      }
      #ros-registry-banner .mint-logo {
        max-width: 200px;
        width: 100%;
        height: auto;
        margin: 0 auto 20px;
        display: block;
        filter: drop-shadow(0 0 10px rgba(255,255,255,0.2));
        user-select: none;
        -webkit-user-drag: none;
      }
      #ros-registry-banner h3 {
        color: #f4f4f4;
        font-weight: 700;
        line-height: 1.35;
        margin: 0 0 10px;
        font-size: 26px;
      }
      #ros-registry-banner .registry-number {
        color: #27c0c0;
        font-size: 18px;
        // margin-top: 12px;
      }
      #ros-registry-banner .registry-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 10px;
      }
      #ros-registry-banner .dots {
        display: inline-flex;
        flex-direction: row;
        gap: 6px;
        margin: 0;
        height: 18px; /* close to text height */
        align-items: center;
      }
      #ros-registry-banner .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #27c0c0;
        box-shadow: 0 0 10px rgba(39,192,192,0.8);
        opacity: 0.9;
        will-change: transform, opacity;
        animation: bob 2.4s infinite ease-in-out;
      }
      #ros-registry-banner .dot:nth-child(2) { animation-delay: 0.2s; }
      #ros-registry-banner .dot:nth-child(3) { animation-delay: 0.4s; }
      @keyframes bob {
        0%, 100% { transform: translateY(0); opacity: 0.7; }
        50% { transform: translateY(-8px); opacity: 1; }
      }

      @media (min-width: 992px) {
        #ros-registry-banner { padding: 90px 0; }
        #ros-registry-banner .mint-logo { margin-bottom: 0; }
        #ros-registry-banner h3 { font-size: 28px; }
      }

      @media (max-width: 992px) {
        /* Tablet & large phones */
        #ros-registry-banner { padding: 72px 0; }
        #ros-registry-banner .container { padding-left: 28px; padding-right: 28px; }
        #ros-registry-banner h3 { font-size: 22px; line-height: 1.45; }
        #ros-registry-banner .emblem-layer .emblem-img {
          left: -26vw;
          width: 120vw;
          opacity: 0.18;
        }
        #ros-registry-banner .registry-number { font-size: 15px; }
        #ros-registry-banner .dots { height: 14px; gap: 5px; }
        #ros-registry-banner .dot { width: 5px; height: 5px; }
      }

      @media (max-width: 576px) {
        /* Small phones */
        #ros-registry-banner { padding: 76px 0; }
        #ros-registry-banner .container { padding-left: 34px; padding-right: 34px; }
        #ros-registry-banner h3 { font-size: 20px; line-height: 1.48; }
        #ros-registry-banner .registry-number { font-size: 14px; }
        #ros-registry-banner .dots { height: 12px; gap: 4px; }
        #ros-registry-banner .dot { width: 4px; height: 4px; }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, [isRussian]);

  if (!isRussian) return null;

  return (
    <section id="ros-registry-banner">
      {/* New positioned emblem above backgrounds, behind content */}
      <div className="emblem-layer">
        <img className="emblem-img" src="img/mintsifry_back.png" alt="" aria-hidden="true" />
      </div>
      {/* overlay removed intentionally */}
      <div className="content">
        <div className="container">
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-md-3 text-center">
              <img
                src="img/Mintsifry_logo.svg"
                alt="Минцифры России"
                className="mint-logo"
                draggable="false"
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
            <div className="col-md-9">
              <h3>{t('RosRegistryBanner.title')}</h3>
              <div className="registry-row">
                
                <div className="registry-number">({t('RosRegistryBanner.registryNumber')})</div>
                {/* <div className="dots" aria-hidden="true">
                  <span className="dot" />
                  <span className="dot" />
                  <span className="dot" />
                </div>               */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RosRegistryBanner;


